module.exports = __webpack_public_path__ + "static/media/Software-Developer-Ahmad-Dalao.ee21beec.pdf";